/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': '⁣⁢Clear selection⁮⁫⁠⁭⁫‌‍⁬⁮‌⁫⁭‌⁬⁯⁯⁫⁮⁠⁯⁪‍⁭‌⁠؜⁣⁤',
  'paginated-picker.async-select.menu-list.error-message.error-message': "⁣⁢Couldn't retrieve data⁪⁭⁠⁡⁯⁮⁠⁠⁬⁮⁡⁮⁮‌‍‍⁯⁬⁭⁫⁪‍⁪‌⁣⁤",
  'paginated-picker.async-select.menu-list.error-message.retry-message': '⁣⁢Click to retry⁪‌⁬⁭⁠‌⁬⁯⁪⁫⁭⁫⁯⁯⁭⁯⁫⁬⁡؜⁯؜⁯‍⁠⁭⁭⁣⁤',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': '⁣⁢Loading...‍⁬⁮؜⁭⁭⁫⁭‍⁡؜‌⁠⁠‌⁡⁡⁠⁮⁬‌⁣⁤',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': '⁣⁢Show more⁮⁠⁪⁡⁠‌؜⁪⁬⁯⁭⁭⁯؜⁬⁫‍⁭⁣⁤',
  'paginated-picker.async-select.pagination-details.of-total-count': '⁣⁢{itemsCount} of {totalCount}⁭⁫؜⁬⁯⁯؜⁠؜⁭⁬‍⁠⁮‍‌‍⁯⁭⁪⁬⁠⁣⁤',
  'paginated-picker.async-select.select.no-options-message.no-options-message': '⁣⁢No matches found؜⁠⁮‌‍⁮⁯⁯⁪‌⁡⁪⁠‌⁠⁮⁬⁮‌⁪⁬⁣⁤',
  'paginated-picker.async-select.select.option.error-message': "⁣⁢Couldn't retrieve data⁬⁮⁠‌؜⁡⁡⁯⁫‍‍⁬⁮⁭‍⁫⁭⁫⁭⁮⁯‌⁪⁬⁭⁣⁤",
  'paginated-picker.async-select.select.option.retry-message': '⁣⁢Click to retry⁬‌؜⁮؜⁫⁬⁭⁬⁯⁯⁬⁮‌‍⁭⁯⁫⁠⁯⁮⁪⁪⁣⁤',
  'paginated-picker.async-select.select.search-placeholder': '⁣⁢Search‍⁭؜‍⁪⁮⁪⁬⁯؜‌⁪⁭⁬؜‍‍⁭⁭⁮⁠⁯⁠⁣⁤',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': '⁣⁢Show full list⁭⁡⁮⁪⁫؜⁬⁫⁮⁪⁮⁭⁡⁫⁠‍⁡⁫⁫⁪⁬‌⁭‍⁣⁤'
};